import { Vendor } from '@melio/platform-api';

export const sortVendors = (vendors: Vendor[]) =>
  Array.from(vendors).sort((a, b) => a.name.localeCompare(b.name, 'en', { sensitivity: 'base' }));
